import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CallCard.module.css';

interface CallTimerDisplayProps {
  formattedDuration: string;
}

export function CallTimerDisplay({ formattedDuration }: CallTimerDisplayProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.callTimer}>
      <div className={styles.timerDisplay}>{formattedDuration}</div>
      <div className={styles.timerLabel}>{t('call:status.callDuration')}</div>
    </div>
  );
}
